export function getChallengeEndTime(date, challengeStarted) {
    let formattedDate = date.split("/");
    const challengeEndDate = new Date(`${formattedDate[1]}/${formattedDate[0]}/${formattedDate[2]} 12:00:00 AM`);

    const localDate = new Date();
    const diffTime = challengeEndDate - localDate;
    if (diffTime < 0) {
        return "This challenge has expired."
    }
    const days = parseInt(diffTime / (1000 * 60 * 60 * 24));
    const hours = parseInt((Math.abs(diffTime) / (1000 * 60 * 60)) % 24);

    if (days >= 1) {
        if (challengeStarted) {
            return `${days} days ${hours} hours until Challenge Expires`;
        } else {
            return `This is a ${days} days challenge`;
        }
    } else {
        const minutes = parseInt(
            (Math.abs(challengeEndDate.getTime() - localDate.getTime()) /
                (1000 * 60)) %
            60
        );
        const seconds = parseInt(
            (Math.abs(challengeEndDate.getTime() - localDate.getTime()) / 1000) %
            60
        );
        if (challengeStarted) {
            return `${hours}:${minutes}:${seconds}`;
        }
        else {
            return `You have ${hours}:${minutes}:${seconds} to complete a challenge`;
        }
    }
}

export function getFormattedDate(date) {
    let d = date.split("-");
    return `${d[2]}/${d[1]}/${d[0]}`;
}

export function compareDates(dateOne, dateTwo) {
    dateOne = dateOne.split("-");
    dateTwo = dateTwo.split("-");
    dateOne = new Date(dateOne[0], dateOne[1] - 1, dateOne[2].substr(0, 2));
    dateTwo = new Date(dateTwo[0], dateTwo[1] - 1, dateTwo[2].substr(0, 2));

    const diffTime = dateOne - dateTwo;
    if (diffTime < 0) {
        return true;
    }
    else {
        return false;
    }
}

/** Function to get my challenges
    params : corporatePrograms -> list of pragrams
            sliceCount -> number of challenges to show
*/
export function getMyVideoList(corporatePrograms, sliceCount) {
    return corporatePrograms
        .sort(function (challengeOne, challengeTwo) {
            if (challengeOne.lastWorkoutTried && challengeTwo.lastWorkoutTried) {
                return compareDates(
                    challengeOne.lastWorkoutTried,
                    challengeTwo.lastWorkoutTried
                )
                    ? 1
                    : -1;
            } else {
                return 0;
            }
        }).filter(item => (item.completedWorkouts > 0 || item.lastWorkoutTried)
            && (item.totalWorkouts != item.completedWorkouts)
            && getChallengeEndTime(getFormattedDate(item.programEndDate), item.lastWorkoutTried ? true : false) != "This challenge has expired.")
        .slice(0, sliceCount);
}

/**
 * Function for challenges object json
 * params : workout -> each workout
 */
export function getWorkoutVideoDetails(workout) {
    return {
        title: workout.videos[0]?.title ?? "-",
        id: workout.id,
        week: workout.programName,
        programThumbnail: workout.programThumbnail ? workout.programThumbnail : null,
        fromDate: getFormattedDate(workout.programStartDate),
        toDate: getFormattedDate(workout.programEndDate),
        status: workout.status,
        totalWorkouts: workout.totalWorkouts,
        lastWorkoutTried: workout.lastWorkoutTried,
        completedWorkouts: workout.completedWorkouts,
        daysToComplete: workout.daysToComplete,
        thumbnail: workout.videos[0]?.thumbnail,
        isCompleted: workout.isCompleted,
        duration: workout.videos[0]?.duration,
        intensity: workout.videos[0]?.intensity,
        categories: workout.videos[0]?.categories,
        tenantName: workout.videos[0]?.tenantName,
        description: workout.description ? workout.description : "",
        is_dynamic_start_date: workout.is_dynamic_start_date,
        type: workout.type,
        assignedId: workout.assigned_id,
    };
}

export function getWorkoutVideoDetailsSMB(workout) {
    return {
        id: workout.id,
        week: workout.programName,
        programThumbnail: workout.programThumbnail ? workout.programThumbnail : null,
        fromDate: getFormattedDate(workout.programStartDate),
        toDate: getFormattedDate(workout.programEndDate),
        status: workout.status,
        totalWorkouts: workout.totalWorkouts,
        lastWorkoutTried: workout.lastWorkoutTried,
        completedWorkouts: workout.completedWorkouts,
        daysToComplete: workout.daysToComplete,
        description: workout.description ? workout.description : "",
        is_dynamic_start_date: workout.is_dynamic_start_date
    };
}

export function getExpireTitle(lastWorkoutTried, toDate, daysToComplete, is_dynamic_start_date, pageName, name='challenge') {
    lastWorkoutTried = new Date(lastWorkoutTried);
    let formateToDate = toDate.toString().split("/").reverse().join("-");
    let endDate = new Date(formateToDate);
    name = name.toLowerCase();
    switch (pageName) {
        case "completed": return `This ${name} was completed on ${lastWorkoutTried.getDate()} ${lastWorkoutTried.toLocaleString('default', { month: 'short' })} ${lastWorkoutTried.getFullYear()}`;
        case "expired": return `This ${name} expired on ${endDate.getDate()} ${endDate.toLocaleString('default', { month: 'short' })} ${endDate.getFullYear()}`;
        case "all": return `This is a  ${daysToComplete} Day ${name}`

        default: return is_dynamic_start_date || formateToDate == new Date().toISOString().split("T")[0] ? getChallengeEndTime(toDate, lastWorkoutTried ? true : false) : `This ${name} is available till ${endDate.getDate()} ${endDate.toLocaleString('default', { month: 'short' })} ${endDate.getFullYear()}`
    }
}